import React  from 'react'
import DropDown from '../dropdown';
import { GetLanguages } from '../../../api/services/shared';

const LanguagesDropDown = ({...props}) => {
    return <DropDown search api={GetLanguages} textField="Name" valueField="Id" {...props}/>
}

export default LanguagesDropDown